<template>
    <ul class="dropdown-menu dropdown-menu--right" :style="style">
        <slot />
    </ul>
</template>
<script>
export default {
    props: {
        top: {
            type: Number,
            required: true
        },

        left: {
            type: Number,
            required: true
        }
    },

    data () {
        return {
            width: 0,
            openClass: 'contextual-menu-open',
            scrollableSelectors: [
                '.board__inner',
                '.column__cards',
                '.panel__content'
            ],
            scrollableElements: []
        }
    },

    mounted () {
        this.width = this.$el.offsetWidth

        // We listen for the scroll event to close the menu so it to avoid the sticky menu
        this.scrollableElements = document.querySelectorAll(this.scrollableSelectors.join(','))

        for (let element of this.scrollableElements) {
            if (!element.classList.contains(this.openClass)) {
                element.classList.add(this.openClass)
            }

            element.addEventListener('scroll', this.onScroll)
        }
    },

    beforeDestroy () {
        // We remove the listener because having multiple listener impacts the performance
        for (let element of this.scrollableElements) {
            if (element.classList.contains(this.openClass)) {
                element.classList.remove(this.openClass)
            }

            element.removeEventListener('scroll', this.onScroll)
        }
    },

    methods: {
        onScroll (event) {
            if (!this.$el.contains(event.target)) {
                this.$emit('close')
            }
        }
    },

    computed: {
        style () {
            return {
                top: `${this.top + 20}px`,
                left: `${this.left - (this.width - 25)}px`
            }
        }
    }
}
</script>
